module.exports = __webpack_public_path__ + "stylesheets/section-company-quote_5452b0cdc350b246c54877c26976fb58.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-company-quote.less
// module id = 7f+t
// module chunks = 154